module.exports = __webpack_public_path__ + "img/b18-2.445fa603.jpg";